<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4 4V14.5C4 15.3284 4.67157 16 5.5 16H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 13.75V10C7 9.17155 7.67157 8.5 8.5 8.5H9.25C10.0784 8.5 10.75 9.17155 10.75 10V13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.75 13.75V7.75C10.75 6.92157 11.4216 6.25 12.25 6.25H13C13.8284 6.25 14.5 6.92157 14.5 7.75V13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'CreativeVelocityIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>